import { FORBIDDEN_ERROR_TOAST_DESCRIPTION } from '../../../constants/forbiddenErrorToastDescription';
import { GENERIC_ERROR_TOAST_DESCRIPTION } from '../../../constants/genericErrorToastDescription';

const isClientErrorStatus = (status: unknown): boolean =>
  typeof status === 'number' && status >= 400 && status < 500;

const isStructuredBody = (data: unknown): data is Record<string, unknown> =>
  !!data && typeof data === 'object' && !Array.isArray(data);

export const getErrorToastDescription = (error: unknown): string => {
  const response = (error as any)?.response;

  if (!isClientErrorStatus(response?.status)) {
    return GENERIC_ERROR_TOAST_DESCRIPTION;
  }

  // A 403 means the user is known but not allowed, so it gets named as a
  // permission problem; a curated errorText from the API still wins.
  const fallback =
    response.status === 403
      ? FORBIDDEN_ERROR_TOAST_DESCRIPTION
      : GENERIC_ERROR_TOAST_DESCRIPTION;

  if (!isStructuredBody(response.data)) {
    return fallback;
  }

  const { errorText } = response.data;

  if (typeof errorText !== 'string') {
    return fallback;
  }

  return errorText.trim() || fallback;
};
